module.exports = __webpack_public_path__ + "static/media/CLOSE_CONTAINER.fa3a60ef.svg";